<div style="display: flex; justify-content: center; align-items: center;">
  <div id="container">
    <div class="mat-expansion-panel old-survey-panel" *ngIf="isOldSurvey">
      <p>{{ 'Previous Year Competition' | translate:{ year: previousYear } }}</p>
    </div>
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <b>{{ 'Progress' | translate }}</b>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class='p-col p-lg-12' *ngFor="let section of Sections">
        <div fxLayout="row" style="margin: 10px;">
          <div class="field-checkbox" style="width: 350px;">
            <p-radiobutton name="sections" [value]="section.groupId" [label]="section.section.text"
              [(ngModel)]="id" (onClick)="radioClicked($event)" inputId="section-radio-{{section.groupId}}"></p-radiobutton>
            <label for="section-radio-{{section.groupId}}" style="margin-left: 8px;">{{ section.section.text }}</label>
          </div>

          <div fxLayout="column" fxLayoutAlign="center center" class="progress-bar">
            <div>{{ section.percentage | percent: '1.0-0' }}</div>
            <mat-progress-bar color="warn" style="margin: auto; width: 100%" [value]="section.percentage * 100"
              [class.completed-progress-bar]="false"></mat-progress-bar>
          </div>
        </div>
      </div>
      <div class='p-col p-lg-12' style="margin: 10px;">
        <!-- <p-radiobutton class="radio" name="sections" [value]="SUMMARY_ID" [label]="'Submit' | translate"
          [(ngModel)]="id" (onClick)="radioClicked($event)">

        </p-radiobutton> -->
        <div class='p-col p-lg-12'>
          <p-radiobutton name="sections" [value]="SUMMARY_ID"
            [(ngModel)]="id" (onClick)="radioClicked($event)" inputId="summary-radio"></p-radiobutton>
          <label for="summary-radio" style="margin-left: 8px;">{{ 'Submit' | translate }}</label>
      </div>
      </div>
    </mat-expansion-panel>
  </div>
</div>
